const Profile = () => import('@/views/Application/Profile/Profile');
const ProfileAccountContactInformation = () => import('@/views/Application/Profile/ContactInformation');
const ProfileAccountChangePassword = () => import('@/views/Application/Profile/ChangePassword');

const ProfileSettingsLanguage = () => import('@/views/Application/Profile/Language');
const ProfileSettingsCalendar = () => import('@/views/Application/Profile/Calendar');
const ProfileSettingsNotifications = () => import('@/views/Application/Profile/Notifications');
const ProfileSettingsJobStatus = () => import('@/views/Application/Profile/JobStatus');
const ProfileSettingsSubscriptions = () => import('@/views/Application/Profile/Subscriptions');
const ProfilePlacements = () => import('@/views/Application/Profile/Placements');
const ProfilePicture = () => import('@/views/Application/Profile/ProfilePicture');

export default [
  {
    path: '/dashboard/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/settings/language',
    name: 'profile-settings-language',
    component: ProfileSettingsLanguage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/settings/calendar',
    name: 'profile-settings-calendar',
    component: ProfileSettingsCalendar,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/settings/notifications',
    name: 'profile-settings-notifications',
    component: ProfileSettingsNotifications,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/settings/jobstatus',
    name: 'profile-settings-job-status',
    component: ProfileSettingsJobStatus,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/settings/subscriptions',
    name: 'profile-settings-subscriptions',
    component: ProfileSettingsSubscriptions,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/account/changepassword',
    name: 'profile-account-change-password',
    component: ProfileAccountChangePassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/account/contact-information',
    name: 'profile-account-contact-information',
    component: ProfileAccountContactInformation,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/account/profile-picture',
    name: 'profile-picture',
    component: ProfilePicture,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/placements',
    name: 'profile-placements',
    component: ProfilePlacements,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/profile/placements/:id',
    name: 'profile-placements-id',
    component: ProfilePlacements,
    meta: {
      requiresAuth: true,
    },
  },
];
